import { Component } from '@angular/core';
import { ConfirmationPopupService } from '../../../services/confirmation-popup.service';
import { ApiService } from '../../../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from '../../../services/toast.service';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { SidebarService } from '../../../services/sidebar.service';

@Component({
  selector: 'app-plan-journey',
  standalone: false,
  templateUrl: './plan-journey.component.html',
  styleUrl: './plan-journey.component.css'
})
export class PlanJourneyComponent {
  rideShareEntires: any[] = []

  showTravelModal = false;

  travelForm!: FormGroup;
  dateFieldType = 'text';
  today: string = '';
  currentUser: any;
  selectedRideId: string | null = null;

  constructor(
    private apiService: ApiService,
    private confirmationPopup: ConfirmationPopupService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private router: Router,
    private sidebarService: SidebarService,
    private authService: AuthService) {
    this.travelForm = this.fb.group({
      name: ['', Validators.required],
      startingPoint: ['', Validators.required],
      destination: ['', Validators.required],
      dateOfTravel: ['', Validators.required],
      adults: [0, [Validators.required, Validators.min(0)]],
      children: [0, [Validators.required, Validators.min(0)]],
    });
    this.currentUser = this.authService.getCurrentUser();
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn;
  }

  ngOnInit() {
    this.sidebarService.setTitle('Plan My Journey');

    this.loadAvailableRides();
    const now = new Date();
    this.today = now.toISOString().split('T')[0];
  }

  ngOnDestroy() {
    this.sidebarService.clearTitle();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  }

  adjustCount(field: 'adults' | 'children', delta: number) {
    const control = this.travelForm.get(field);
    if (!control) return;
    const newValue = Math.max(0, control.value + delta);
    control.setValue(newValue);
  }

  onSubmit() {
    if (this.travelForm.valid) {
      var formValue = this.travelForm.getRawValue();

      let postData: any = {
        FullName: formValue.name,
        StartingPoint: formValue.startingPoint,
        Destination: formValue.destination,
        DateOfTravel: new Date(formValue.dateOfTravel),
        AdultsAvailable: formValue.adults,
        ChildrenAvailable: formValue.children
      };

      const travelDate = new Date(postData.DateOfTravel);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      travelDate.setHours(0, 0, 0, 0);

      if (travelDate < today) {
        this.toastService.error('Travel date cannot be less than today');
        return;
      }

      let endPoint: string;

      if (this.selectedRideId) {
        endPoint = 'updateRide';
        postData.id = this.selectedRideId;
      }
      else {
        endPoint = 'createRide'
      }

      this.apiService.postData(`Ride/${endPoint}`, postData).subscribe({
        next: () => {
          this.toastService.success('Travel plan updated successfully');
          this.travelForm.reset();
          this.travelForm.patchValue({
            adults: 0,
            children: 0
          });
          this.loadAvailableRides();
          this.closeTravelModal();
        },
        error: () => {
          this.toastService.error('Something went wrong')
        }
      });

    }
  }

  switchToDate() {
    this.dateFieldType = 'date';
  }

  resetIfEmpty(input: HTMLInputElement) {
    if (!input.value) {
      this.dateFieldType = 'text';
    }
  }

  triggerDateInput(input: HTMLInputElement) {
    this.dateFieldType = 'date';
    setTimeout(() => input.click());
  }

  editRide(ride: any) {

    this.showTravelModal = true;
    this.selectedRideId = ride.id;

    const parts = new Date(ride.dateOfTravel).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).split('/');

    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;

    this.travelForm.patchValue({
      name: ride.offeredBy,
      startingPoint: ride.startingPoint,
      destination: ride.destination,
      dateOfTravel: formattedDate,
      adults: ride.availableSeats.adults,
      children: ride.availableSeats.children
    });
  }

  openManageModal() {
    if (!this.authService.isLoggedIn) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/planJourney' } });
    }
    let name = this.currentUser?.unique_name;
    if (name) {
      this.travelForm.get('name')!.patchValue(name);
    }
    this.showTravelModal = true;
  }

  closeTravelModal() {
    this.showTravelModal = false;
    this.selectedRideId = null;
  }

  loadAvailableRides() {
    this.apiService.getData('Ride/availableRides').subscribe({
      next: (data: any[]) => {
        this.rideShareEntires = data;
      }
    })
  }

  onDelete(ride: any) {
    this.confirmationPopup.open('Are you sure you want to delete your travel plan?', {
      onAccept: () => {
        this.apiService.postData('Ride/deleteRides', { rideIds: [ride.id] }).subscribe({
          next: () => {
            this.toastService.success('Your ride has been deleted successfully');
            this.loadAvailableRides();
          },
          error: () => {
            this.toastService.error('Something went wrong');
          }
        })
      },
      onReject: () => { }
    });
  }
}